import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../api/client';
import type { StoryWithClaims } from '@news-assist/shared';

interface StoryDetailResponse {
  story: StoryWithClaims;
  claims: Array<{
    id: string;
    content: string;
    claim_type: string;
    urgency: number;
    recency_score: number;
    question: string;
    subject?: { name: string; entity_type: string };
    predicate?: string;
    source_count: number;
  }>;
  claim_count: number;
  material_count: number;
  entity_count: number;
}

export function useStory(id: string) {
  return useQuery({
    queryKey: ['story', id],
    queryFn: async () => {
      const response = await apiClient.get<StoryDetailResponse>(`/stories/${id}/detail`);
      // Merge claims into story object for backward compatibility
      return {
        ...response.story,
        claims: response.claims,
        claim_count: response.claim_count,
        material_count: response.material_count,
        entity_count: response.entity_count,
      };
    },
    enabled: !!id,
  });
}
